import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Edit } from '../../constructor/work/Edit';
import { EventRemoveDrainFunnel, EventUpdateDrainFunnel } from '../../helpers/events';
import { useHandlerNotificationApp } from '../../hooks/useHandlerNotificationApp';
import {
  ControlPointObjectType,
  CreateDrainFunnelType,
  DataDrainFunnel,
} from '../../constructor/types';
import { InputHeightPoint } from '../InputHeightPoint';
import { ChangeHeightModal } from './ChangeHeightModal';
import { COLORS_CONST } from '../../helpers/styles';
import { DrainFunnelObject } from '../../constructor/meshes/DrainFunnelObject';
import { DrainLineObject } from '../../constructor/meshes/DrainLine/DrainLineObject';
import { SlopedSurfaceComponent } from './SlopedSurfaceComponent';

export const DrainFunnel = () => {
  const { addNotification } = useHandlerNotificationApp();
  const [isDrainFunnelObject, setIsDrainFunnelObject] = useState(() => Edit.drainFunnel !== null);
  const [isSloped, setIsSloped] = useState(Edit.slopedSurface !== null);
  const [modalHeightPoints, setModalHeightPoints] = useState(false);
  const [dataDrainObjects, setDataDrainObjects] = useState<Array<DataDrainFunnel>>(() => {
    if (Edit.drainFunnel) {
      return Edit.drainFunnel.getParamsData();
    }
    return [];
  });
  const [dataControlPoints] = useState<Array<ControlPointObjectType>>(
    Edit.sectionsObjects?.controlsPointsObjects || []
  );
  const [currHeightsPoints, setCurrHeightsPoints] = useState<Array<number>>(() => {
    if (Edit.slopedSurface) {
      return Edit.slopedSurface.getHeightsPoints();
    }
    return [];
  });

  const handlerButtonAddDrain = (type: CreateDrainFunnelType) => {
    const isCreate = Edit.addDrainFunnel(type);
    setIsDrainFunnelObject(isCreate);
    if (!isCreate) {
      addNotification({
        messageError: 'Для добавления воронки, нужно сначала добавить сектор.',
        typeMessage: 'warning',
      });
    }
  };
  const handlerButtonRemoveDrain = () => {
    Edit.removeDrainFunnel();
  };
  const handlerRemoveDrainFunnelObject = () => {
    setIsDrainFunnelObject(false);
    setDataDrainObjects([]);
    setIsSloped(false);
    setCurrHeightsPoints([]);
  };
  const handlerUpdateDrainFunnelObject = () => {
    if (Edit.drainFunnel) {
      setDataDrainObjects(Edit.drainFunnel.getParamsData());
    } else {
      setDataDrainObjects([]);
    }
  };
  const changeHeightPoint = (heightPoint: number, uuid: string) => {
    // if (Edit.drainFunnel) {
    //   handlerButtonRemoveDrain();
    // }
    // if (Edit.slopedSurface) {
    //   handlerButtonRemoveSlopedSurface();
    // }
    const calcHeight = Edit.totalPointHeight - heightPoint / 1000;
    Edit.drainFunnel?.changeHeightFunnel(calcHeight, uuid);
  };
  const handlerButtonAddSlopedSurface = () => {
    const isCreate = Edit.createSlopedSurface();
    setIsSloped(isCreate);
    // setCurrHeightsPoints(Edit?.slopedSurface?.getHeightsPoints || []);
    if (!isCreate) {
      addNotification({
        messageError: 'Для добавления уклона, нужно сначала добавить сектор.',
        typeMessage: 'warning',
      });
    }
  };
  const handlerButtonRemoveSlopedSurface = () => {
    if (Edit.slopedSurface) {
      setIsSloped(false);
      setCurrHeightsPoints([]);
      Edit.removeSlopedSurface();
    }
  };
  const getDataControlPoints = () => {
    if (dataControlPoints.length) {
      return dataControlPoints.map((item, index) => {
        let h = (item.position.y * 1000).toFixed();
        if (currHeightsPoints[index]) {
          h = (currHeightsPoints[index] * 1000).toFixed();
        }
        return (
          <InputHeightPoint
            uuid={item.uuid}
            changeHeightObject={changeHeightPoint}
            namePoint={item.textObject?.text || '$'}
            key={`${item.uuid}}`}
            text={h}
            label={`Точка ${item.textObject?.text || '$'}`}
          />
        );
      });
    }
    return null;
  };
  const updateHeightsSloped = () => {
    if (Edit.slopedSurface) {
      setCurrHeightsPoints(Edit.slopedSurface.getHeightsPoints());
    }
  };

  useEffect(() => {
    window.addEventListener(EventRemoveDrainFunnel, handlerRemoveDrainFunnelObject);
    window.addEventListener(EventUpdateDrainFunnel, handlerUpdateDrainFunnelObject);
    return () => {
      window.removeEventListener(EventRemoveDrainFunnel, handlerRemoveDrainFunnelObject);
      window.removeEventListener(EventUpdateDrainFunnel, handlerUpdateDrainFunnelObject);
    };
  }, []);

  return (
    <>
      <Typography fontSize={24} color="#fff">
        ШАГ 3
      </Typography>
      <Typography mb={3} color="#fff">
        Укажите высоту покрываемая плоскости, добавьте необходимое количество точек, а также укажите
        сливную воронку, если таковая имеется
      </Typography>
      <Button
        disabled={Edit.drainFunnel instanceof DrainLineObject || isSloped}
        fullWidth
        variant="contained"
        onClick={
          isDrainFunnelObject ? handlerButtonRemoveDrain : () => handlerButtonAddDrain('point')
        }
        sx={{
          fontSize: '12px',
          marginBottom: '10px',
          backgroundColor: isDrainFunnelObject ? COLORS_CONST.red : COLORS_CONST.systemButton,
          // '&:disabled': {
          //   color: 'rgba(255,255,255,0.35)',
          //   backgroundColor: 'rgba(0, 0, 0, 0.35)',
          // },
        }}
      >
        {isDrainFunnelObject ? 'Удалить точку воронки' : 'Добавить точку воронки'}
      </Button>
      <Button
        disabled={Edit.drainFunnel instanceof DrainFunnelObject || isSloped}
        fullWidth
        variant="contained"
        onClick={
          isDrainFunnelObject ? handlerButtonRemoveDrain : () => handlerButtonAddDrain('line')
        }
        sx={{
          fontSize: '12px',
          marginBottom: '10px',
          backgroundColor: isDrainFunnelObject ? COLORS_CONST.red : COLORS_CONST.systemButton,
        }}
      >
        {isDrainFunnelObject ? 'Удалить линию воронки' : 'Добавить линию воронки'}
      </Button>
      <Button
        disabled={!!Edit.drainFunnel}
        fullWidth
        variant="contained"
        onClick={isSloped ? handlerButtonRemoveSlopedSurface : handlerButtonAddSlopedSurface}
        sx={{
          fontSize: '12px',
          marginBottom: '10px',
          backgroundColor: isSloped ? COLORS_CONST.red : COLORS_CONST.systemButton,
        }}
      >
        {isSloped ? 'Удалить уклон' : 'Добавить уклон'}
      </Button>
      {isSloped && <SlopedSurfaceComponent updateSloped={updateHeightsSloped} />}
      <Button
        fullWidth
        variant="contained"
        onClick={() => {
          setModalHeightPoints(true);
          handlerButtonRemoveDrain();
          handlerButtonRemoveSlopedSurface();
        }}
        sx={{
          marginBottom: '10px',
          '&:disabled': {
            color: 'rgba(255,255,255,0.35)',
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
          },
        }}
      >
        Высота всех точек
      </Button>
      {dataDrainObjects.length ? (
        <Typography fontWeight={600} color="#fff">
          Высоты воронок:
        </Typography>
      ) : null}
      <Box
        maxHeight="400px"
        overflow="auto"
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
      >
        {dataDrainObjects.map(item => (
          <InputHeightPoint
            uuid={item.uuid}
            changeHeightObject={changeHeightPoint}
            namePoint={item.symbolFunnel}
            key={`${item.symbolFunnel}`}
            text={((Edit.totalPointHeight - item.heightDrainFunnel) * 1000).toFixed()}
            label={`Точка ${item.symbolFunnel}`}
          />
        ))}
        {dataControlPoints.length ? (
          <Typography width="100%" marginTop={3} fontWeight={600} color="#fff">
            Высоты точек:
          </Typography>
        ) : null}
        {getDataControlPoints()}
      </Box>
      <ChangeHeightModal
        closeModal={() => setModalHeightPoints(false)}
        isOpen={modalHeightPoints}
      />
    </>
  );
};
